module.exports = __webpack_public_path__ + "static/media/jishuzhichi.c0fe95ea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/jishuzhichi.svg
// module id = 641
// module chunks = 0